import { takeLatest, put } from 'redux-saga/effects';
import { getPaginatedListSaga } from '../../../store/structures';
import { types, actions } from './duck';
import { getAllList } from '../../coupons/api';
import { markAsFavouriteSaga, removeFavouriteSaga } from '../favourite/saga';

export function* reloadCouponsSaga() {
  yield put(actions.getAllList());
}

export default function* saga() {
  yield takeLatest(
    types.GET_ALL_LIST,
    getPaginatedListSaga(actions, getAllList),
  );
  yield takeLatest(types.MARK_AS_FAVOURITE, markAsFavouriteSaga);
  yield takeLatest(types.REMOVE_FAVOURITE, removeFavouriteSaga);
  yield takeLatest(types.RELOAD_COUPONS, reloadCouponsSaga);
}
